// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreRfqQuoteDetailsState from "@store/Framework/Store/Store/Pages/RfqQuoteDetails/StoreRfqQuoteDetailsState";
import { Draft } from "immer";

const initialState: StoreRfqQuoteDetailsState = {
    quoteLastModifiedOn: 0,
    rfqDetailsDocuments: [],
    uploadMessage: "",
    uploadLimitExceeded: false,
    quoteAdditionalInfo: {},
};

const actions = {
    "Store/Pages/RfqQuoteDetails/GetQuoteLastModifiedOn": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { quoteLastModifiedOn: Number },
    ) => {
        draft.quoteLastModifiedOn = action.quoteLastModifiedOn;
    },
    "Store/Pages/RfqQuoteDetails/GetRfqDetailsDocuments": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { rfqDetailsDocuments: string[] },
    ) => {
        draft.rfqDetailsDocuments = action.rfqDetailsDocuments;
    },
    "Store/Pages/RfqQuoteDetails/SetRfqDetailsDocuments": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { rfqDetailsDocuments: string[] },
    ) => {
        draft.rfqDetailsDocuments = action.rfqDetailsDocuments;
    },
    "Store/Pages/RfqQuoteDetails/SetRfqDetailsAddDocuments": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { docName: string },
    ) => {
        draft.rfqDetailsDocuments?.push(action.docName);
    },
    "Store/Pages/RfqQuoteDetails/SetRfqDetailsDocumentUploadMsg": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { documentUploadMsg: string },
    ) => {
        draft.uploadMessage = action.documentUploadMsg;
    },
    "Store/Pages/RfqQuoteDetails/RemoveRfqDetailsDocument": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { removeDocument: string },
    ) => {
        draft.rfqDetailsDocuments = draft.rfqDetailsDocuments?.filter(document => document !== action.removeDocument);
    },
    "Store/Pages/RfqQuoteDetails/GetQuoteAdditionalInfo": (
        draft: Draft<StoreRfqQuoteDetailsState>,
        action: { quoteAdditionalInfo: any },
    ) => {
        draft.quoteAdditionalInfo = action.quoteAdditionalInfo;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreRfqQuoteDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
